import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import type { FC, ReactElement} from 'react';

import { appStore } from '@stores/appStore';

export const HistoryObserver: FC = ({ children }): ReactElement => {
  const { setLocation, locationHistory } = appStore;

  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== locationHistory.to) setLocation(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <>{children}</>;
};
